;( function( $, window, document ) { // eslint-disable-line
    function sticky_relocate() {
        var window_top = $(window).scrollTop();
        var div_top = $('#sticky-anchor').offset().top;
        if (window_top > div_top) {
            $('#sticky').addClass('is-sticky');
            $('#sticky-anchor').height($('#sticky').outerHeight());
        } else {
            $('#sticky').removeClass('is-sticky');
            $('#sticky-anchor').height(0);
        }
    }

    if ($('#sticky-anchor')[0]) {
        $(window).scroll(sticky_relocate);
        sticky_relocate();
    }

} )( jQuery, window, document );
